import React from 'react';

export default function Footer() {
  return (
    <div>
      <p>© 2022 CazVid LLC | <a href="https://cazvid.com">CazVid.com</a> | <a href="https://cazvid.com/privacy/">Privacy and Terms &amp; Conditions</a></p>
    </div>
  );
};